// extracted by mini-css-extract-plugin
export var chip = "_56-9";
export var chipLabel = "_56-a";
export var close = "_56-7";
export var closeIcon = "_56-8";
export var error = "_56-6";
export var infoTooltip = "_56-2";
export var innerContainer = "_56-1";
export var input = "_56-b";
export var medium = "_56-5";
export var outerContainer = "_56-0";
export var small = "_56-4";
export var xSmall = "_56-3";